import { Country, Appdomain } from './enums';

export const CART_API_PREFIX = '/api';
export const API_PREFIX = '/myaccount-api';

export type CountryMap<T> = {
    [Country.DE]: T;
    [Country.FR]: T;
    [Country.NL]: T;
    [Country.BENL]: T;
    [Country.BEFR]: T;
    [Country.FI]: T;
    [Country.DK]: T;
    [Country.SE]: T;
    [Country.AT]: T;
    [Country.CHDE]: T;
    [Country.CHFR]: T;
    [Country.UK]: T;
    [Country.IT]: T;
    [Country.PL]: T;
    [Country.ES]: T;
    [Country.CS]: T;
};

export type AppdomainMap<T> = {
    [Appdomain.DE]: T;
    [Appdomain.FR]: T;
    [Appdomain.NL]: T;
    [Appdomain.BENL]: T;
    [Appdomain.BEFR]: T;
    [Appdomain.COM]: T;
    [Appdomain.AT]: T;
    [Appdomain.CHDE]: T;
    [Appdomain.CHFR]: T;
    [Appdomain.UK]: T;
    [Appdomain.IT]: T;
    [Appdomain.PL]: T;
    [Appdomain.ES]: T;
    [Appdomain.CS]: T;
};

export const COUNTRY_APPDOMAIN_MAP: CountryMap<Appdomain> = {
    [Country.DE]: Appdomain.DE,
    [Country.FR]: Appdomain.FR,
    [Country.NL]: Appdomain.NL,
    [Country.BENL]: Appdomain.BENL,
    [Country.BEFR]: Appdomain.BEFR,
    [Country.FI]: Appdomain.COM,
    [Country.DK]: Appdomain.COM,
    [Country.SE]: Appdomain.COM,
    [Country.AT]: Appdomain.AT,
    [Country.CHDE]: Appdomain.CHDE,
    [Country.CHFR]: Appdomain.CHFR,
    [Country.UK]: Appdomain.UK,
    [Country.IT]: Appdomain.IT,
    [Country.PL]: Appdomain.PL,
    [Country.ES]: Appdomain.ES,
    [Country.CS]: Appdomain.CS,
};

export const APPDOMAIN_COUNTRY_MAP: AppdomainMap<Country> = {
    [Appdomain.DE]: Country.DE,
    [Appdomain.FR]: Country.FR,
    [Appdomain.NL]: Country.NL,
    [Appdomain.BENL]: Country.BENL,
    [Appdomain.BEFR]: Country.BEFR,
    [Appdomain.COM]: Country.FI,
    [Appdomain.AT]: Country.AT,
    [Appdomain.CHDE]: Country.CHDE,
    [Appdomain.CHFR]: Country.CHFR,
    [Appdomain.UK]: Country.UK,
    [Appdomain.IT]: Country.IT,
    [Appdomain.PL]: Country.PL,
    [Appdomain.ES]: Country.ES,
    [Appdomain.CS]: Country.CS,
};

export const LATEST = 'latest';
export const ALL_ORDERS = 'all';
export const LATEST_MONTHS = 6;

export const DEFAULT_ORDER_LIST_LIMIT = 5;

export const FORCE_RETURN_FLOW_COOKIE = 'force_return';

export const ENABLE_NEW_RETURN_FLOW_COOKIE = 'enable_new_return_flow';

// interface CountrySalesChannelDefintion {
//     id: string;
//     locale: string;
// }

// export const APPDOMAIN_SALES_CHANNEL: AppdomainMap<CountrySalesChannelDefintion> = {
//     [Appdomain.DE]: {
//         id: '549a0fed-e0f1-45fa-83ad-b5a16080ff22',
//         locale: 'de_DE',
//     },
//     [Appdomain.FR]: {
//         id: 'a332da49-a665-4a13-bd44-1ecea09b4d86',
//         locale: 'fr_FR',
//     },
//     [Appdomain.NL]: {
//         id: 'c2cc09de-7d7a-440b-ad6c-35527625b07e',
//         locale: 'nl_NL',
//     },
//     [Appdomain.BENL]: {
//         id: 'e42097e0-7bcf-434a-8647-4b06ea43e6d4',
//         locale: 'nl_BE',
//     },
//     [Appdomain.BEFR]: {
//         id: 'e42097e0-7bcf-434a-8647-4b06ea43e6d4',
//         locale: 'fr_BE',
//     },
//     [Appdomain.COM]: {
//         id: '927d8073-baad-49d5-a975-321813874877',
//         locale: 'en_GB',
//     },
//     [Appdomain.AT]: {
//         id: '92420e60-86b5-4d0b-af28-3d896571b019',
//         locale: 'de_AT',
//     },
//     [Appdomain.CHDE]: {
//         id: 'e4c5d078-d823-4232-aba9-6eb1e4e5297d',
//         locale: 'de_CH',
//     },
//     [Appdomain.CHFR]: {
//         id: 'e4c5d078-d823-4232-aba9-6eb1e4e5297d',
//         locale: 'fr_CH',
//     },
//     [Appdomain.UK]: {
//         id: 'c3e00c90-1edd-48bb-801a-ec5b73ecaf74',
//         locale: 'en_GB',
//     },
//     [Appdomain.IT]: {
//         id: '9519fbb0-4ff6-4525-ab9c-f526919ec803',
//         locale: 'it_IT',
//     },
//     [Appdomain.PL]: {
//         id: 'e5168407-8d6f-4d9d-95e1-7e6fa5a6382c',
//         locale: 'pl_PL',
//     },
//     [Appdomain.ES]: {
//         id: 'b69973d1-d62f-4fd2-89a8-1dfed090b6be',
//         locale: 'es_ES',
//     },
// };
